import { types } from "mobx-state-tree";
import { AuthStore } from "./AuthStore";
import { UIStore } from "./UIStore";
import { AppointmentStore } from "./entities/appointment/AppointmentStore";
import { AppointmentReasonStore } from "./entities/appointment-reasons/AppointmentReasonStore";
import { BookingStore } from "./entities/booking/BookingStore";
import { BreedStore } from "./entities/breeds/BreedStore";
import { ClinicStore } from "./entities/clinics/ClinicStore";
import { InsuranceCompanyStore } from "./entities/insurance-companies/InsuranceCompanyStore";
import { PetStore } from "./entities/pets/PetStore";
import { SpeciesStore } from "./entities/species/SpeciesStore";
import { TermsStore } from "./entities/terms/TermsStore";
import { TimeslotStore } from "./entities/timeslots/TimeslotStore";
import { UserStore } from "./entities/user/UserStore";
import type { Instance } from "mobx-state-tree";

export const RootStore = types.model("RootStore", {
  uiStore: types.optional(UIStore, {}),
  authStore: types.optional(AuthStore, {}),
  termsStore: types.optional(TermsStore, {}),
  userStore: types.optional(UserStore, {}),
  petsStore: types.optional(PetStore, {}),
  breedsStore: types.optional(BreedStore, {}),
  insuranceCompanyStore: types.optional(InsuranceCompanyStore, {}),
  clinicsStore: types.optional(ClinicStore, { shouldShowSearch: false }),
  bookingStore: types.optional(BookingStore, {}),
  appointmentReasonStore: types.optional(AppointmentReasonStore, {}),
  timeslotsStore: types.optional(TimeslotStore, {}),
  appointmentStore: types.optional(AppointmentStore, {}),
  speciesStore: types.optional(SpeciesStore, {}),
});

export type RootStoreInstance = Instance<typeof RootStore>;
